import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
const b = bemClassBuilder('v-journey-action-button-skeleton');
export const JourneyActionButtonSkeleton = observer(({ type }) => {
    return _jsx("div", { className: b.block({ type }) });
});
JourneyActionButtonSkeleton.displayName = 'JourneyActionButtonSkeleton';
